<template>
  <span
    class="icon"
    :style="maskStyle"
    aria-hidden="true"
  />
</template>

<script setup>
import { computed } from 'vue'
import appleIcon from '@/assets/icons/itunes_notes.svg'

const maskStyle = computed(() => ({
  WebkitMask: `url(${appleIcon}) center / contain no-repeat`,
  mask: `url(${appleIcon}) center / contain no-repeat`
}))
</script>

<style scoped>
.icon {
  width: 26px;
  height: 26px;
  display: inline-block;
  background-color: currentColor;
}
</style>
